import { useState, useEffect } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import UploadForm from './upload_form';

import '../../../css/popup.css';

function FileUploadNurse_popup() {

    const [data, setData] = useState([]);
    const [atchDta, setAtchDta] = useState([]);
    const [head, setHead] = useState([]);
    const [excelData, setExcelData] = useState({});
    const [output, setOutput] = useState([]);
    const [checked, setChecked] = useState('');
    const [replace, setReplace] = useState([]);
    const [changed, setChanged] = useState([]);
    const sendData = JSON.parse(localStorage.getItem('tableData')) || {};

    const popupData = async () => {
        try {
            const response = await axios.get('/trmsapi/obthrc/excel_upload_resource.do', {
                params: {
                    tableName: sendData.tableName,
                    tableOwner: sendData.tableOwner,
                }
            });
            setData(response.data);
        } catch (e) {
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    }

    const handleFileChange = (e) => {
        if (e.target.files[0] !== undefined) {
            setAtchDta(e.target.files[0]); //TF로 변경
            const file = e.target.files[0];
            const reader = new FileReader();

            reader.onload = (evt) => {
                const bstr = evt.target.result;
                const wb = XLSX.read(bstr, { type: 'base64' });
                const headers = {};
                Object.keys(wb.SheetNames).forEach((i) => {
                    const sheet = `Sheet${Number(i) + 1}`;
                    const wsname = wb.SheetNames[i];
                    const ws = wb.Sheets[wsname];
                    const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
                    return headers[sheet] = data[0];
                });
                console.log(headers);
                setChecked(wb.SheetNames[0]);
                setOutput(wb.SheetNames[0]);
                setHead(headers);
                setExcelData(to_json(wb));
                console.log(wb.SheetNames);
            };
            reader.readAsArrayBuffer(file);
        } else {
            setAtchDta([]);
            setHead([]);
            setExcelData([]);
            setOutput([]);
            setChecked('');
            setChanged([]);
            return;
        }
    };

    const to_json = (workbook) => {
        const result = {};
        workbook.SheetNames.forEach((sn) => {
            const sheet = workbook.Sheets[sn];
            const rows = XLSX.utils.sheet_to_json(sheet, {
                header: 'A',     // 첫 행을 header로 사용
                defval: '',      // 빈 셀은 공백 처리
            });
            if (rows.length > 0) {
                result[sn] = rows;
            }
        });
        return result;
    };

    const initChanged = (head, data) => {
        if (head === undefined) {
            return;
        } else {
            const mapped = head.reduce((acc, row, idx) => {
                const key = String.fromCharCode(65 + idx);
                const item = data.find(item => item.COMMENTS === row);
                const value = item ? item.COLUMN_NAME : '';
                acc[key] = value;
                return acc;
            }, {});
            setChanged(mapped);
        };
    }

    const save = async () => {
        console.log(changed);
        console.log(replace);
        if (atchDta.length === 0) {
            alert('선택된 파일이 없습니다.');
            return false;
        }
        if (changedValid(changed) === 'T') {
            alert('중복 선택한 항목이 있습니다. ');
            return false;
        }
        replace.unshift(changed);
        saveLogic(replace, "/trmsapi/obthrc/excel_upload_nurse.do");
    };

    const saveLogic = async (data, url) => {
        const payload = new URLSearchParams({
            emogcode: sendData.emogCode,
            excData: JSON.stringify(data),
            userId: localStorage.getItem("id"),
        });

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: payload,
            });

            if (!response.ok) {
                throw new Error(`서버 오류: ${response.status}`);
            }

            const resultText = await response.text();
            console.log('저장 결과:', resultText);

            alert('저장이 완료되었습니다.');
        } catch (error) {
            console.error('저장 중 오류 발생:', error);
            alert('저장에 실패했습니다. 관리자에게 문의하세요.');
        }
    }

    const exit = () => {
        window.close();
    }

    const handelOptions = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...changed,
            [name]: value
        };
        setChanged(newParams);
    };

    const changedValid = (change) => {
        var result = 'F';
        var length = head[checked].length
        for (var i = 0; i < length; i++) {
            var key = change[String.fromCharCode(65 + i)];
            if (Object.values(change).filter((i) => key === i).length > 1) {
                result = 'T';
                break;
            }
        }
        return result;
    }

    useEffect(() => {
        popupData();

    }, []);

    useEffect(() => {
        initChanged(head[checked], data);
        const currentSheet = excelData[checked];
        if (!currentSheet || !Array.isArray(currentSheet)) {
            setReplace([]);
            return;
        }
        setReplace(currentSheet.slice(1));
    }, [excelData]);

    return (
        <UploadForm
            atchDta={atchDta}
            handleFileChange={handleFileChange}
            setChecked={setChecked}
            checked={checked}
            output={output}
            sendData={sendData}
            excelData={excelData}
            replace={replace}
            head={head}
            data={data}
            handelOptions={handelOptions}
            save={save}
            exit={exit}
            title={"간호사"}
            changed={changed}
        />
    );
}


export default FileUploadNurse_popup;